import React, { useEffect, useState } from "react";
import { Button, Row, Col, Modal } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import SearchIcon from "@mui/icons-material/Search";
import { useGetFaqsQuery } from "../../../../features/user/userApiSlice";
import Loader from "../../../../components/Loader";
import { getAsset } from "../../../../helpers/helper";
const Frequentlyquestions = () => {
  // Modal States
  const [showModal, setShowModal] = useState(false);
  const [activeFAQ, setActiveFAQ] = useState(null);

  const { data: faqRes, isLoading: loading } = useGetFaqsQuery("sellerFaq");
  const sellerfaq = faqRes?.data?.faq || [];

  const handleOpenModal = (item) => {
    setActiveFAQ(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setActiveFAQ(null);
  };

  return (
    <div className="customer-support-faq">
      <Row className="customer-support-faq-row">
        <p className="phera-faq mt-4 mb-0">
          FAQ (Frequently Asked Questions)
        </p>

        {/* Search */}
        <div className="customer-support-search-wrap mt-2">
          <div className="iput-search customer-support-search d-flex align-items-center">
            <SearchIcon />
            <input
              placeholder="What do you need help with?"
              className="input-ipt no-outline border-0 ps-3 w-100"
            />
          </div>
        </div>

        {/* FAQ List */}
        <Row className="customer-support-faq-list">
          {loading ? (
            <Loader heightsetting="screenHeight" />
          ) : (
            sellerfaq?.map((item, index) => (
              <Col xs={12} md={6} key={index}>
                <Accordion>
                  <Accordion.Item className="mt-4">
                    <Accordion.Header className="phera-faq">
                      {item?.topic}
                    </Accordion.Header>
                    <Accordion.Body>{item?.question}</Accordion.Body>

                    <Button
                      className="ms-3 mb-2"
                      variant="primary"
                      onClick={() => handleOpenModal(item)}
                    >
                      Learn Now
                    </Button>
                  </Accordion.Item>
                </Accordion>
              </Col>
            ))
          )}
        </Row>
      </Row>

      {/* ================= MODAL ================= */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        centered
        scrollable
        dialogClassName="customer-support-faq-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>FAQ Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Topic */}
          <div
            style={{
              background: "#fff",
              padding: "12px 15px",
              borderRadius: "8px",
              boxShadow:
                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
              marginBottom: "12px",
            }}
          >
            <h6 style={{ fontWeight: "600", color: "#0d6efd" }}>Topic</h6>
            <p style={{ margin: 0, color: "#6c757d" }}>{activeFAQ?.topic}</p>
          </div>

          {/* Question */}
          <div
            style={{
              background: "#fff",
              padding: "12px 15px",
              borderRadius: "8px",
              boxShadow:
                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
              marginBottom: "12px",
            }}
          >
            <h6 style={{ fontWeight: "600", color: "#0d6efd" }}>Question</h6>
            <p style={{ margin: 0, color: "#6c757d" }}>{activeFAQ?.question}</p>
          </div>

          {/* Answer */}
          <div
            style={{
              background: "#fff",
              padding: "12px 15px",
              borderRadius: "8px",
              boxShadow:
                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
              marginBottom: "12px",
            }}
          >
            <h6 style={{ fontWeight: "600", color: "#0d6efd" }}>Answer</h6>
            <p style={{ margin: 0, color: "#6c757d" }}>{activeFAQ?.answer}</p>
          </div>

          {/* Image */}
          {activeFAQ?.image?.[0] && (
            <div
              style={{
                background: "#fff",
                padding: "12px 15px",
                borderRadius: "8px",
                boxShadow:
                  "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
                marginTop: "12px",
              }}
            >
              <h6 style={{ fontWeight: "600", color: "#0d6efd" }}>
                Reference Image
              </h6>
              <img
                src={getAsset(activeFAQ?.image?.[0])}
                alt="FAQ"
                style={{
                  maxHeight: "240px",
                  width: "100%",
                  objectFit: "cover",
                  borderRadius: "6px",
                }}
                crossOrigin="anonymous"
              />
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Frequentlyquestions;
